import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import PermissionPopupModal from "../modals/PermissionPopupModal/PermissionPopupModal";
import { ENTITLEMENT_REQUIRED_EVENT } from "../../services/entitlementPrompt";
import { PERMISSION_ACTIONS } from "../../constants/permissionActions";

// Client, 20/10/2026: the chat limit popup also offers the member's chats.
const EXTRA_LINKS = {
  [PERMISSION_ACTIONS.CHAT_GROUPS_UNLIMITED_THEMATIC]: { label: "Gestisci le mie chat", to: "/chat" },
};

// The same refusal can arrive twice (a screen retrying, two lists at once).
const REPEAT_WINDOW_MS = 1500;

/**
 * Shows the CRM popup ("Passa a Premium") when the backend refuses something
 * the member's plan doesn't include (Premium Lite). Mounted once, inside the
 * router so the popup's buttons can navigate.
 */
const EntitlementPromptHost = () => {
  const [prompt, setPrompt] = useState(null);
  const last = useRef({ key: null, at: 0 });
  const actionsBySlug = useSelector((state) => state.permissions?.actionsBySlug);

  useEffect(() => {
    const onRequired = (event) => {
      const { permission, message } = event.detail || {};
      const key = `${permission}|${message}`;
      const now = Date.now();
      if (last.current.key === key && now - last.current.at < REPEAT_WINDOW_MS) return;
      last.current = { key, at: now };
      setPrompt({ permission, message });
    };

    window.addEventListener(ENTITLEMENT_REQUIRED_EVENT, onRequired);
    return () => window.removeEventListener(ENTITLEMENT_REQUIRED_EVENT, onRequired);
  }, []);

  // The CRM's popup text for that action wins over the server's placeholder.
  const message =
    (prompt?.permission && actionsBySlug?.[prompt.permission]?.popup_text) ||
    prompt?.message ||
    "";
  const title = (prompt?.permission && actionsBySlug?.[prompt.permission]?.popup_title) || null;

  return (
    <PermissionPopupModal
      isOpen={prompt !== null}
      setIsOpen={(open) => {
        if (!open) setPrompt(null);
      }}
      message={message}
      title={title}
      extraLink={(prompt?.permission && EXTRA_LINKS[prompt.permission]) || null}
    />
  );
};

export default EntitlementPromptHost;
